import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl-next';

import { SpotlightManager, SpotlightTarget, SpotlightTransition } from '@atlaskit/onboarding';

import { useChoreographerAssets } from '@confluence/choreographer-services';

import { messages } from '../messages';
import { useLoomScriptReadTimeContext } from '../context/LoomScriptReadTimeContext';

import spotlightHero from './assets/SpotlightHero.svg';

export type LoomScriptExtensionSpotlightWrapperProps = {
	children: React.ReactNode;
};

export const LoomScriptExtensionSpotlightWrapper = ({
	children,
}: LoomScriptExtensionSpotlightWrapperProps) => {
	const { isLoomScriptReadTimeSpotlightShown, dismissLoomScriptReadTimeSpotlight } =
		useLoomScriptReadTimeContext();
	const { formatMessage } = useIntl();
	const { Spotlight } = useChoreographerAssets();
	return (
		<SpotlightManager>
			<SpotlightTarget name="loomAIScriptSection">{children}</SpotlightTarget>
			<SpotlightTransition>
				{isLoomScriptReadTimeSpotlightShown && (
					<Spotlight
						image={spotlightHero}
						heading={formatMessage(messages.spotlightHeading)}
						target="loomAIScriptSection"
						dialogPlacement="left bottom"
						dialogWidth={275}
						actions={[
							{
								text: formatMessage(messages.spotlightButtonLabel),
								onClick: dismissLoomScriptReadTimeSpotlight, // TODO analytics
							},
						]}
					>
						<FormattedMessage {...messages.spotlightBody} />
					</Spotlight>
				)}
			</SpotlightTransition>
		</SpotlightManager>
	);
};
